import { IExtendedFormlyFieldConfig } from './form.types';

export const CALCULATION_EDITABLE = 'calculationEditable--true';

export const SECTION_HEADER_FORM_CONFIG: IExtendedFormlyFieldConfig = {
  type: 'section-header',
  templateOptions: {
    label: 'Section header',
    title: 'Section title',
  },
};
